import React, { useState } from 'react';
import { InputComponent } from '../form/InputComponent';
import { useDispatch, useSelector } from 'react-redux';
import { resetPassword, selectUser, setUser, updateUser } from 'src/reducers/account.reducer';
import _ from 'lodash';
import {
  ButtonSubmitContainer,
  PersonalInformationsContainer,
  PersonalInformationsFormContainer,
  RowContainer,
  StyledInfos,
  Subtitle,
} from './PersonalInformations.styles';
import { Button } from '../Button';
import TitlePage from '../titlePage/TitlePage';
import { ACCOUNT_ROLES } from 'src/utils/constants';
import { RiLock2Fill } from 'react-icons/ri';
import { addEventTracking } from 'src/utils/utils';
import { toast } from 'react-toastify';

interface PersonalInformationsProps {}
const PersonalInformations: React.FC<PersonalInformationsProps> = () => {
  const dispatch: any = useDispatch();
  const user = useSelector(selectUser);

  const [formData, setFormData] = useState({
    name: user?.name,
    firstName: user?.firstName,
    email: user?.email,
    phoneNumber: user?.phoneNumber,
    role: user?.role,
  });

  const handleUserInfosChange = (name, value, id, e) => {
    if (name.target) {
      value = name.target.value;
      name = name.target.name;
    }

    setFormData(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    let updatedUser = _.cloneDeep(user);

    updatedUser = {
      ...updatedUser,
      ...formData,
    };
    dispatch(updateUser({ userId: updatedUser._id, data: updatedUser }));
    dispatch(setUser(updatedUser));
    toast.info('Informations utilisateurs mis à jour');
  };

  const accountRoleOptions = [
    { label: 'Administrateur', value: ACCOUNT_ROLES.ADMIN },
    { label: 'Referent RGPD', value: ACCOUNT_ROLES.AccountOfficer },
    { label: 'Client', value: ACCOUNT_ROLES.Guest },
    { label: 'Commerciale', value: ACCOUNT_ROLES.Sales },
  ];

  const handleResetPassword = async () => {
    addEventTracking('Password', 'Reset');
    await dispatch(resetPassword({ email: user.email }));
    toast.info(
      'Votre demande a bien été prise en compte.Si vous possédez un compte, un mail vous a été envoyé avec les instructions de réinitialisation.'
    );
  };

  return (
    <PersonalInformationsContainer>
      <TitlePage title='Informations personnelles' />

      <Subtitle>Informations du compte</Subtitle>
      <PersonalInformationsFormContainer>
        <RowContainer>
          <InputComponent sharable={false} type={'text'} label={'Nom'} name={'name'} onChange={handleUserInfosChange} value={formData.name} />

          <InputComponent
            sharable={false}
            type={'text'}
            label={'Prénom'}
            name={'firstName'}
            onChange={handleUserInfosChange}
            value={formData.firstName}
          />
        </RowContainer>
        <RowContainer>
          <InputComponent
            disabled={!(user.role === ACCOUNT_ROLES.AccountOfficer || user.role === ACCOUNT_ROLES.ADMIN)}
            sharable={false}
            type={'text'}
            label={'E-mail'}
            name={'email'}
            onChange={handleUserInfosChange}
            value={formData.email}
          />
          <InputComponent
            sharable={false}
            type={'text'}
            label={'Téléphone'}
            name={'phoneNumber'}
            onChange={handleUserInfosChange}
            value={formData.phoneNumber}
          />
        </RowContainer>
        <RowContainer>
          <InputComponent
            disabled={true}
            onChange={handleUserInfosChange}
            type='select'
            name={'role'}
            options={accountRoleOptions}
            label={"Rôle de l'utilisateur"}
            sharable={false}
            value={accountRoleOptions.find(option => option.value === formData.role)}
          />
        </RowContainer>
        <ButtonSubmitContainer>
          <Button label={'Sauvegarder les modifications'} onClick={handleSubmit} />
        </ButtonSubmitContainer>
      </PersonalInformationsFormContainer>

      <Subtitle> Réinitialiser le mot de passe </Subtitle>

      <StyledInfos
        action={{ text: 'Réinitialisation du mot de passe', onClick: handleResetPassword }}
        icon={RiLock2Fill}
        text={'Vous pouvez <b>réinitialiser votre mot de passe </b>, en cliquant sur ce boutton :)'}
      />
    </PersonalInformationsContainer>
  );
};

export default PersonalInformations;
